export default {
    listagem: {
        titulo_pagina: 'Revisión de Resultados',
        table: {
            recipiente: 'Contenedor',
            informacoes: 'Información',
            paciente: 'Paciente',
            exames: 'Exámenes',
            vns: 'VNS',
            empresa: 'Empresa',
            usuario_edicao: 'Usuario Editando',
            ultima_atualizacao: 'Última actualización',
            acoes: 'Acciones'
        },
        confirmacao_cancelamento: {
            titulo: 'Cancelación',
            mensagem: '¿Está seguro de que desea cancelar los resultados de esta revisión? Esta acción no se puede deshacer.'
        }
    },
    form: {
        titulo_pagina: 'Editar Resultados en Revisión',
        sem_resultados: 'No hay más resultados para revisar.',
        outro_usuario: 'Este resultado está siendo editado por otro usuario.',
        fieldsets: {
            informacoes: 'Información',
            exames: 'Exámenes'
        },
        fields: {
            recipiente: {
                label: 'Contenedor'              
            },
            paciente: {
                label: 'Paciente'
            },
            vns: {
                label: 'VNS',
            },
            empresa: {
                label: 'Empresa',
            },
            ultima_atualizacao: {
                label: 'Última actualización'
            },
            exame: {
                label: 'Examen'                
            },
            exame_ordem: {
                label: 'Examen de orden'
            },
            material: {
                label: 'Material'
            },
            resultado: {
                label: 'Resultado'
            },
            unidade_medida: {
                label: 'Unidad de medida'
            },
            erro_mapeamento: {
                label: 'Error de Mapeo',
                mensagem: 'Algunos campos de este examen no fueron mapeados correctamente.'
            },
            edit:{
                resultado: {
                    label: 'Nuevo Resultado',
                    description: 'Introduzca el nuevo resultado para el examen.'
                },
                unidade_medida: {
                    label: 'Nueva Unidad de Medida',
                    description: 'Introduzca la nueva unidad de medida para el examen.'
                },
                motivo: {
                    label: 'Motivo',
                    description: 'Explique el motivo de la modificación.'
                }
            },
            cancelar_resultados: 'Cancelar Resultados',
            botao_salvar: 'Guardar resultado y enviar',
            botao_salvar_proximo: 'Guardar resultado, Enviar e Ir al Siguiente',
        },
        update: {
            success: '¡Resultado editado con éxito!',
            error: '¡Error al editar el resultado!',
            warning: 'El resultado ha sido enviado al sistema de origen.'
        },
        cancel: {
            success: '¡Resultados cancelados con éxito!',
            error: '¡Error al cancelar los resultados!'
        },
        list: {
            error: 'Ocurrió un error al intentar cargar los datos de la pantalla!'
        },
        validation: {
            motivo_required: 'El motivo es obligatorio.',
            motivo_maxlength: 'El motivo no puede exceder 500 caracteres.',
            resultado_required: 'El resultado es obligatorio.',
            resultado_maxlength: 'El resultado no puede exceder 255 caracteres.',
            unidade_medida_required: 'La unidad de medida es obligatoria.',
            unidade_medida_maxlength: 'La unidad de medida no puede exceder 255 caracteres.'
        }
    }
}
